export default "__VITE_ASSET__CdkuBQiW__"